import {Pipe, PipeTransform} from "@angular/core";
import { Version } from "../model/version.class";

@Pipe({name: 'versionsOfMedia'})
export class FilterVersionsOfMedia implements PipeTransform {
    transform(versions: Version[], showAll) {
        if (showAll) {
            return versions;
        }

        let filteredVersions = versions.filter(
            version => (version.versionStatus === 'Neu' || version.versionStatus === 'Unfertig')
        )

        // Finde die letzte Freigegebene Version
        let freigegebenVersions = versions.filter( version => version.versionStatus === 'Freigegeben');
        let lastDate = new Date(0,0,0);
        let lastVersion: Version;
        for (let version of freigegebenVersions) {
            if (version.versionStatus === 'Freigegeben' && new Date(version.createdAt) > lastDate) {
                lastDate = new Date(version.createdAt);
                lastVersion = version;
            } 
        }
        filteredVersions.push(lastVersion);
        return filteredVersions;

    }

    
}


// WEBPACK FOOTER //
// ./src/app/pipes/filterVersionsOfMedia.ts